import React, { JSX } from "react";
import { Container } from "./Description.styled";
import { colors } from "../../../../styles/theme";

export type DescriptionProps = {} & React.ComponentProps<typeof Container>;

export const Description: React.FC<DescriptionProps> = (props): JSX.Element => {
  const { ...rest } = props;
  return (
    <Container {...rest} variant="v1" sx={{
      color: colors.text.v3,
    }} />
  );
};
